import { InjectionToken } from '@angular/core';
export const NAVIGATION_OPTIONS = new InjectionToken('NavigationOptions');
//# sourceMappingURL=navigation-options.js.map